import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { setupErrorHandling } from './utils/errorHandler'
import { SessionContextProvider } from '@supabase/auth-helpers-react'
import { supabase } from './integrations/supabase/client'
import { SentryErrorBoundary } from './components/SentryErrorBoundary'
import { initSentry } from './utils/logger'

// Initialize Sentry first
initSentry();

// Then setup error handling overrides for console methods
setupErrorHandling();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SessionContextProvider supabaseClient={supabase}>
      <SentryErrorBoundary>
        <App />
      </SentryErrorBoundary>
    </SessionContextProvider>
  </React.StrictMode>,
)